var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1458 14.5833H15.3125L15 14.2708C16.0417 13.125 16.6667 11.5625 16.6667 9.89583C16.6667 6.14583 13.6458 3.125 9.89583 3.125C6.14583 3.125 3.125 6.14583 3.125 9.89583C3.125 13.6458 6.14583 16.6667 9.89583 16.6667C11.5625 16.6667 13.125 16.0417 14.2708 15L14.5833 15.3125V16.1458L19.7917 21.3542L21.3542 19.7917L16.1458 14.5833ZM9.89583 14.5833C7.29167 14.5833 5.20833 12.5 5.20833 9.89583C5.20833 7.29167 7.29167 5.20833 9.89583 5.20833C12.5 5.20833 14.5833 7.29167 14.5833 9.89583C14.5833 12.5 12.5 14.5833 9.89583 14.5833Z",
    fill: "#5F6368",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search2.13d45898893b3c2478689653a6de87e5.svg";
export { ForwardRef as ReactComponent };